module.exports = __webpack_public_path__ + "img/open-eye.15adb83a.svg";